module.exports = __webpack_public_path__ + "img/v Boetzelaerlaan voor.ea50f542.jpg";